import { ArrowRight, LogIn } from 'lucide-react';
import { LOGIN_URL, REGISTER_URL } from '../lib/links';

export function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero-orb hero-orb--gold" aria-hidden="true" />
      <div className="hero-orb hero-orb--violet" aria-hidden="true" />

      <div className="container hero-inner">
        <span className="hero-badge">
          <span className="dot" />
          LDS Token · Web3 Ecosystem
        </span>

        <h1 className="hero-title">
          ALPHA <span className="accent">ONE</span>
        </h1>

        <p className="hero-sub">
          A next-generation <b>decentralized Web3 ecosystem</b> built on transparency, innovation
          and community.
        </p>

        <p className="hero-tagline">
          Empowering the future through blockchain innovation — a sustainable network where
          individuals grow, lead, and succeed together. The future starts here.
        </p>

        <div className="hero-cta">
          <a href={REGISTER_URL} className="btn btn-gold btn-lg">
            Join Alpha One <ArrowRight size={18} />
          </a>
          <a href={LOGIN_URL} className="btn btn-outline btn-lg">
            <LogIn size={18} /> Member Login
          </a>
        </div>
      </div>

      <span className="hero-scroll">Scroll</span>
    </section>
  );
}
